// SupportVideos.jsx
import React, { useState, useEffect, useRef } from "react";
import "../../styles/SupportVideos.css";

const videoList = [
  {
    id: 1,
    title: "How to use viewer",
    videoId: "4ZShFRr_k8c", // https://youtu.be/4ZShFRr_k8c
    description: "DICOM : demonstration for Radiologist"
  },
  {
    id: 2,
    title: "How to save your personnel report formats",
    videoId: "ysz5S6PUM-U", 
    description: "Learn how to save and manage your report formats"
  },
  {
    id: 3,
    title: "How autocompletion works in editor",
    videoId: "jNQXAC9IVRw", 
    description: "Understanding autocompletion feature in DICOM editor"
  },
  {
    id: 4,
    title: "How to login on DICOM pacs",
    videoId: "ScMzIvxBSi4", 
    description: "Step by step login process for DICOM PACS"
  },
  {
    id: 5,
    title: "How to share case to patient on whatsapp",
    videoId: "aqz-KE-bpKQ", 
    description: "Share medical cases with patients via WhatsApp"
  }
];
export default function SupportVideos({ onClose }) {
  const [activeVideo, setActiveVideo] = useState(videoList[0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [iframeKey, setIframeKey] = useState(0); 

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);
  const handleCloseClick = () => {
    if (onClose) {
      onClose();
    }
  };
  const handleVideoSelect = (video) => {
    setActiveVideo(video);
    setIframeKey(prev => prev + 1);
  };
  const filteredVideos = videoList.filter(video =>
    video.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div className="support-videos-container">
      {/* Top Right Close Button (X) */}
      <button 
        className="support-videos-close-btn-top"
        onClick={handleCloseClick}
        aria-label="Close"
      >
        ✕
      </button>
      <div className="support-videos-sidebar">
        <div className="support-videos-sidebar-header">
          <h2>FAQ and guides</h2>
        </div>

        <div className="support-videos-search">
          <input
            type="text"
            placeholder="Search guides..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="support-videos-search-input"
          />
        </div>
        <div className="support-videos-menu">
          {filteredVideos.map((video) => (
            <div
              key={video.id}
              className={`support-videos-menu-item ${
                activeVideo.id === video.id ? "active" : ""
              }`}
              onClick={() => handleVideoSelect(video)}
            >
              {video.title}
            </div>
          ))}
          {filteredVideos.length === 0 && (
            <div className="support-videos-no-results">
              No videos found
            </div>
          )}
        </div>
      </div>
      <div className="support-videos-content">
        <h1 className="support-videos-title">{activeVideo.title}</h1>
        
        <div className="support-videos-player-wrapper">
          <div className="support-videos-player">
            <iframe
              key={iframeKey} 
              src={`https://www.youtube.com/embed/${activeVideo.videoId}?autoplay=0`}
              title={activeVideo.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div> 
        </div>
        <div className="support-videos-description">
          <strong>DICOM :</strong> {activeVideo.description}
          <br />
          <span className="support-videos-subtitle">
            DICOM : Digitalizing Healthcare Workflow
          </span>
          <button 
            className="support-videos-close-btn-bottom"
            onClick={handleCloseClick}
            aria-label="Close"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
}